import React, { memo, useEffect, useContext } from "react";
import Header from '../Components/Header';
import Slider from '../Components/Slider';
import FooterSection from '../Components/FooterSection';
import FactSheet from "../Components/FactSheet";
import KeyFeatures from "../Components/KeyFeatures";
import HomeAboutSection from "../Components/HomeAboutSection";
import HttpHelper from '../service/httpService';

const HomePage = (props) => {

    window.onbeforeunload = function () {
        window.scrollTo(0, 0);
    }

    const titleWebsite = "Trailboss Enterprises, Inc";
    const descriptionWebsite = "";

    const getFooterDetails = async () => {
        await HttpHelper.get("website/GetSettingData").then((response) => {
            localStorage.setItem('WebsiteSetting', JSON.stringify(response.data))
        }).catch((error) => {
            console.log(error);
        })
    }

    useEffect(() => {
        getFooterDetails();
        document.title = titleWebsite;
        document.getElementsByTagName("meta")[2].content = descriptionWebsite;
        document.description = descriptionWebsite;
        window.scrollTo(0, 0);

    }, [titleWebsite, descriptionWebsite]);

    return (
        <>
            <Header />
            <Slider
                titleOne="Aviation Support Services"
                subtitleOne="Aircraft flightline maintenance services (rotary & fixed-wing) management control, hangar programmed and scheduled maintenance, arrival, ground handling, replenishing, departure, emergency response, disaster preparedness, special event & exercise program planning, training management services, crash recovery, and technical order management."
                bannerOne="/assets/images/slider/fighter-jet.jpg"
                titleTwo="Logistics Support"
                subtitleTwo="Worldwide life-cycle management of aircraft sub systems, airfield services, base supply management, deployment support, material requisitioning, detailed documentation, asset disposition, inventory control, shipping and receiving and general warehousing."
                bannerTwo="/assets/images/slider/tourist-bus.jpg"
                titleThree="Facilities Operation & Maintenance (O&M)"
                subtitleTree="Operation and Maintenance of Government owned facilities including management, supervision, highly motivated craftsman to include engineers (Heat / Chill Plant) and HVAC Technicians."
                bannerThree="/assets/images/slider/security-guard.jpg"
                titleFour="Aerospace Ground Equipment (AGE)"
                subtitleFour="Total program management: Inspection, evaluation, repair, refurbishment & corrosion control, painting, operational check-out and certification (to design specifications) of AGE and ground support equipment (GSE), to include fleet-wide programmed maintenance management."
                bannerFour="/assets/images/slider/fire-bus.jpg"
            />
            <KeyFeatures bgClass="blackBg" />
            <HomeAboutSection bgClass="blackBg" />
            <FactSheet bgClass="blackBg" style={{ marginBottom: '20px' }} />
            <FooterSection />
            {/*  <BlogData bgClass="blackBg" />*/}
        </>
    )
}

export default memo(HomePage);